import * as React from 'react';
import { connect } from 'react-redux';
import './VehicleDetails.css';
import KPInputTextArea from '../../../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';

class VehicleDetails extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            engineNo: this.props.sales.engineNumber,
            vinNo: this.props.sales.vinNumber,
            submitted: false,
            nextDisabled: true
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSkipStep = this.handleSkipStep.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
    }

    async componentDidMount() {
        this.checkSubmit();
    }

    async checkSubmit() {
        let valid = (this.state.engineNo.trim().length > 0 || this.state.vinNo.trim().length > 0);
        await this.setState({ nextDisabled: !valid });
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        this.checkSubmit();
    }

    async handleSkipStep() {
        let payload = {
            engineNumber: "",
            vinNumber: "",
        }
        await this.props.dispatchAction(setQuoteData(payload));
        await this.props.dispatchAction(handleNextStep());
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            let payload = {
                engineNumber: this.state.engineNo,
                vinNumber: this.state.vinNo,
            }
            await this.props.dispatchAction(setQuoteData(payload));
            await this.props.dispatchAction(handleNextStep());
        }
    }

    public render() {
        return (
            <div className="container">
                <div>
                    <p className="text-center">
                        Thanks! Next, we need your car’s engine and VIN numbers.
                    </p>
                    <p className="text-center">
                        (You can find them on your licence disk. Can’t check it now? Just add these details later.)
                    </p>
                    <p className="text-center">
                        Psst, if you ever claim, having this info will help us speed up the process.
                    </p>
                </div>

                <div className="form-row mt-4">
                    <div className="col-12">
                        <KPInputTextArea
                            id="txtEngineNo"
                            name="engineNo"
                            type="input"
                            className="mb-15px"
                            label={"Engine no. (optional)"}
                            alwaysShowLabel={false}
                            value={this.state.engineNo}
                            notice={this.state.submitted}
                            noticeType={"error"}
                            noticeMessage={"Invalid engine no."}
                            successTick={false}
                            required={true}
                            readOnly={false}
                            autoFocus={false}
                            minLength={3}
                            maxLength={false}
                            disabled={false}
                            form="mainform"
                            handleChange={(e) => this.handleChange(e)}
                            />
                    </div>

                    <div className="col-12 mt-1">
                        <KPInputTextArea
                            id="txtVinNo"
                            name="vinNo"
                            type="input"
                            className="mb-15px"
                            label={"Vin no. (optional)"}
                            alwaysShowLabel={false}
                            value={this.state.vinNo}
                            notice={this.state.submitted}
                            noticeType={"error"}
                            noticeMessage={"Invalid vin no."}
                            successTick={false}
                            required={true}
                            readOnly={false}
                            autoFocus={false}
                            minLength={3}
                            maxLength={false}
                            disabled={false}
                            form="mainform"
                            handleChange={(e) => this.handleChange(e)}
                            />
                    </div>
                </div>

                <div className="row mt-lg-4">
                    <div className="col-md-6 text-right">
                        <button type="button" className="btn btn-outline-red btnNavigate mt-4 mt-lg-0" onClick={this.handleSkipStep}>Skip</button>
                    </div>

                    <div className="col-md-6 text-left">
                        <button type="button" className="btn btn-solid-red btnNavigate mt-4 mt-lg-0" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleDetails);